<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
//import { cn } from '~/utils/cn'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div
    :class="
      cn(
        'flex flex-col-reverse sm:flex-row sm:justify-center sm:gap-x-2 mt-auto',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
